document.addEventListener("DOMContentLoaded", () => {
  const hero = document.querySelector(".wonder-app-hero");
    if (hero)  {
			setTimeout(() => {
				hero.classList.add("animate");
		  }, 500);
		}


    const elements = document.querySelectorAll(".js-animate");
    const observers = new Map();

    elements.forEach((el) => {
      const rootMargin = el.dataset.rootMargin || "0px";

      if (!observers.has(rootMargin)) {
          observers.set(
          rootMargin,
          new IntersectionObserver(
              (entries, obs) => {
              entries.forEach((entry) => {
                  if (!entry.isIntersecting) return;
                  entry.target.classList.add("is-in-view");
                  obs.unobserve(entry.target);
              });
              },
              { root: null, threshold: 0, rootMargin }
          )
          );
      }

      observers.get(rootMargin).observe(el);
      
    });
  
    const loadVideo = (source) => {
      const video = source.closest("video");
      const src = source.dataset.src;
      if (!src) return;

      source.src = src;
      source.removeAttribute("data-src"); // better than delete dataset
      video.load(); // starts fetch based on preload rules
    };

    const io = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const video = entry.target;
          video.querySelectorAll("source[data-src]").forEach(loadVideo);
          obs.unobserve(video);
        });
      },
      { rootMargin: "300px 0px" }
    );

    document.querySelectorAll("video").forEach((v) => io.observe(v));
});
